/**
 * UserBadge — pequeño chip con nombre + email del usuario actual + botón
 * logout. Pensado para insertarse en AppShell.
 *
 * Sprint 16: el user viene del cache en memoria de lib/auth (alimentado por
 * /me o el login); useSyncExternalStore re-renderiza el chip ante
 * login/logout sin prop-drilling. El logout ahora REVOCA la sesión
 * server-side (fila Session tombstoneada) y el backend limpia la cookie
 * httpOnly con un Set-Cookie de borrado — best-effort: aunque la red falle,
 * limpiamos el cache local y redirigimos; la sesión caducará sola por idle.
 */
import { useSyncExternalStore } from 'react'
import { LogOut, User } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { getCurrentUser, logout as authLogout, subscribeCurrentUser } from '@/lib/auth'

export function UserBadge() {
  const navigate = useNavigate()
  const user = useSyncExternalStore(subscribeCurrentUser, getCurrentUser)

  async function logout() {
    await authLogout()
    navigate('/login', { replace: true })
  }

  if (!user) return null

  return (
    <div className="flex items-center gap-2 text-xs">
      <div className="flex items-center gap-1.5 px-2 py-1 rounded border border-ink-900/10 bg-white">
        <User className="size-3 text-ink-700/60" />
        <div className="leading-tight">
          <div className="font-medium text-ink-900">{user.name ?? user.email}</div>
          {user.name && (
            <div className="text-[10px] font-mono text-ink-700/50">{user.email}</div>
          )}
        </div>
      </div>
      <button
        type="button"
        onClick={() => void logout()}
        className="bp-btn"
        title="Cerrar sesión"
      >
        <LogOut className="size-3" />
        Salir
      </button>
    </div>
  )
}

export default UserBadge
